import { default as BackgroundModeDto } from '../impl/BackgroundModeDto';
import { default as BeaconDto } from '../impl/BeaconDto';
import { default as BeaconSensitivityDto } from '../impl/BeaconSensitivityDto';
import { default as CountryDto } from '../impl/CountryDto';
import { default as DeviceAccountDto } from '../impl/DeviceAccountDto';
import { default as FloorPlanDto } from '../impl/FloorPlanDto';
import { default as FloorPlanTourDto } from '../impl/FloorPlanTourDto';
import { default as FloorPlanTranslationDto } from '../impl/FloorPlanTranslationDto';
import { default as FontAlignmentDto } from '../impl/FontAlignmentDto';
import { default as FontFamilyDto } from '../impl/FontFamilyDto';
import { default as FontSizeUnitDto } from '../impl/FontSizeUnitDto';
import { default as FontStyleDto } from '../impl/FontStyleDto';
import { default as LanguageDto } from '../impl/LanguageDto';
import { default as Legacy_FloorPlanDto } from '../impl/Legacy_FloorPlanDto';
import { default as MediumDto } from '../impl/MediumDto';
import { default as MenuItemDto } from '../impl/MenuItemDto';
import { default as MenuItemKeywordDto } from '../impl/MenuItemKeywordDto';
import { default as MenuItemTranslationDto } from '../impl/MenuItemTranslationDto';
import { default as PinTypeDto } from '../impl/PinTypeDto';
import { default as RoleDto } from '../impl/RoleDto';
import { default as ScreenOrientationDto } from '../impl/ScreenOrientationDto';
import { default as SiteDto } from '../impl/SiteDto';
import { default as SiteObjectDto } from '../impl/SiteObjectDto';
import { default as SiteObjectKeywordDto } from '../impl/SiteObjectKeywordDto';
import { default as SiteObjectOnFloorPlanDto } from '../impl/SiteObjectOnFloorPlanDto';
import { default as SiteObjectTranslationDto } from '../impl/SiteObjectTranslationDto';
import { default as SiteObjectTypeDto } from '../impl/SiteObjectTypeDto';
import { default as SiteSupportedLanguageDto } from '../impl/SiteSupportedLanguageDto';
import { default as StyleDto } from '../impl/StyleDto';
import { default as TourDto } from '../impl/TourDto';
import { default as TourMenuItemDto } from '../impl/TourMenuItemDto';
import { default as TourRelatedSiteObjectDto } from '../impl/TourRelatedSiteObjectDto';
import { default as TourStatusDto } from '../impl/TourStatusDto';
import { default as TourSubTypeDto } from '../impl/TourSubTypeDto';
import { default as TourSupportedLanguageDto } from '../impl/TourSupportedLanguageDto';
import { default as TourTranslationDto } from '../impl/TourTranslationDto';
import { default as TourTypeDto } from '../impl/TourTypeDto';
import { default as UserDto } from '../impl/UserDto';

import type { INSTANTIATOR_INTERFACES } from '../interface/instantiator';

const InstantiateMap: INSTANTIATOR_INTERFACES = {
    IBackgroundModeDto: BackgroundModeDto,
    IBeaconDto: BeaconDto,
    IBeaconSensitivityDto: BeaconSensitivityDto,
    ICountryDto: CountryDto,
    IDeviceAccountDto: DeviceAccountDto,
    IFloorPlanDto: FloorPlanDto,
    IFloorPlanTourDto: FloorPlanTourDto,
    IFloorPlanTranslationDto: FloorPlanTranslationDto,
    IFontFamilyDto: FontFamilyDto,
    IFontStyleDto: FontStyleDto,
    IFontSizeUnitDto: FontSizeUnitDto,
    IFontAlignmentDto: FontAlignmentDto,
    ILanguageDto: LanguageDto,
    IMediumDto: MediumDto,
    IMenuItemDto: MenuItemDto,
    IMenuItemKeywordDto: MenuItemKeywordDto,
    IMenuItemTranslationDto: MenuItemTranslationDto,
    IPinTypeDto: PinTypeDto,
    IRoleDto: RoleDto,
    IScreenOrientationDto: ScreenOrientationDto,
    ISiteDto: SiteDto,
    ISiteObjectDto: SiteObjectDto,
    ISiteObjectOnFloorPlanDto: SiteObjectOnFloorPlanDto,
    ISiteObjectKeywordDto: SiteObjectKeywordDto,
    ISiteObjectTranslationDto: SiteObjectTranslationDto,
    ISiteObjectTypeDto: SiteObjectTypeDto,
    ISiteSupportedLanguageDto: SiteSupportedLanguageDto,
    IStyleDto: StyleDto,
    ITourDto: TourDto,
    ITourMenuItemDto: TourMenuItemDto,
    ITourRelatedSiteObjectDto: TourRelatedSiteObjectDto,
    ITourStatusDto: TourStatusDto,
    ITourSubTypeDto: TourSubTypeDto,
    ITourTranslationDto: TourTranslationDto,
    ITourTypeDto: TourTypeDto,
    ITourSupportedLanguageDto: TourSupportedLanguageDto,
    IUserDto: UserDto,

    ILegacy_FloorPlanDto: Legacy_FloorPlanDto,
} as const;

function instantiate<
    Interface extends keyof INSTANTIATOR_INTERFACES,
    Constructor extends INSTANTIATOR_INTERFACES[Interface],
    ApiData extends Parameters<Constructor>[0],
    Response extends ReturnType<Constructor>,
>(className: Interface, data: Partial<ApiData>): Response {
    const constructor = InstantiateMap[className];

    if (!constructor) {
        throw new Error(`Unable to find instantiator for: ${className}`);
    }

    return constructor(data) as Response;
}

function allInterfaces(): (keyof INSTANTIATOR_INTERFACES)[] {
    return Object.keys(InstantiateMap) as (keyof INSTANTIATOR_INTERFACES)[];
}

export default Object.freeze({
    instantiate,
    allInterfaces,
});
